var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: { id: "rename-modal", title: "Rename" },
      on: {
        ok: function ($event) {
          return _vm.$emit("change", _vm.name)
        },
        close: function ($event) {
          return _vm.$emit("close")
        },
      },
    },
    [
      _c("b-form-input", {
        model: {
          value: _vm.name,
          callback: function ($$v) {
            _vm.name = $$v
          },
          expression: "name",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }